import React, { Component } from "react";
// import FormViewer from "../components/FormViewer";
// import LoaderButton from "../components/LoaderButton";
// import Modal from '../components/Modal'
import HttpServices from "../utils/Http.services";
// import { checkTranslation, getObject, translate } from "../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import moment from "jalali-moment";
// import SidebarView from '../components/SidebarView';
// import ButtonAnimated from "../components/buttons/ButtonAnimated";
// import { nanoid } from "nanoid";
// import TableViewer from "../components/TableViewer";
import Header from "../components/header/Header";
import CollectionView from "../windows/Applets/database/CollectionView";
import RecordContentViewer from "./RecordContentViewer";
import StagesManager from "../components/StagesManager";
import PageViewer from "../windows/PageViewer";
import { checkTranslation, replaceVariablesLabelWithKeys, setObject, translate } from "../utils/useful";
import { framesConfig } from "../variables/framesStatics";
import CustomLoader from "../components/CustomLoader";

class RecordViewerModal extends Component {

    state = {
        countries: [],
        frame: {},
        // actions: {
        //     submit: { key: "submit", label: "{{lang}}submit", bgColor: this.props.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))', color: '#fff', function: this.submitForm, loader: "isPostingData" },
        //     cancel: { key: "cancel", label: "{{lang}}cancel", color: '#777', bgColor: '#e1e1e1', function: this.backAction },

        // },
        default: { _id: 'details', name: '{{lang}}Details' },
        currentTab: 'details',
        headerConfig: {
            backAction: () => this.backAction,
            // 'title': "View Record",
            // 'subtitle': this.props.page?.subtitle,

        }
    }

    componentDidMount() {

        if (!this.props.frame) {
            this.getFrame()

        } else {

            // if (Array.isArray(this.props.frame?.relatedFrames) && this.props.frame?.relatedFrames.length > 0) {
            //     this.setHeader("showRelatedFrames", true)
            // }

        }

        this.checkDefaultTab()

    }


    componentDidUpdate(prevProps) {
        // console.log('hereeeeeeeeeeeeeeeeeee11',this.props.page);
        // if (JSON.stringify(this.props.page) != JSON.stringify(prevProps.page)) {
        //     this.getFrame()
        // }

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.checkDefaultTab()

        }

        if ((JSON.stringify(this.props.windowData.params ?? {}) != JSON.stringify(prevProps.windowData.params ?? {}))) {
            this.checkDefaultTab()
        }
    }


    backAction = () => {

        this.props.functionsHandler(null, 'closeOverlayFrame', { id: 'recordViewer' })
        this.onClose()
    }

    checkDefaultTab = () => {
        let windowData = this.props.windowData
        let frame = this.props.frame ?? this.state.frame
        let relatedFrames = frame?.relatedFrames


        let page = 'details'
        let currentFrame
        let currentFrameFilter
        let relevantInfo
        let applet = JSON.parse(JSON.stringify(this.props.applet))

        let currentFrameAppletInfo

        // console.log(windowData.params)
        if (windowData.params?.relevant && Array.isArray(relatedFrames)) {
            let frameId = windowData.params?.relevant

            for (let i = 0; i < relatedFrames.length; i++) {
                const relatedFrame = relatedFrames[i]?.frame;


                if (relatedFrame._id == frameId) {

                    // console.log(relatedFrames[i])

                    relevantInfo = JSON.parse(JSON.stringify(relatedFrames[i]))


                    if (relatedFrames[i].applet && typeof relatedFrames[i].applet == 'object') {
                        applet = relatedFrames[i].applet
                    }


                    currentFrame = JSON.parse(JSON.stringify(relatedFrame))
                    page = relatedFrame.type

                    if (relatedFrames[i]?.settings.field) {
                        let filterKey = relatedFrames[i]?.settings.field
                        if (relatedFrames[i]?.settings.objectKey) {
                            filterKey = filterKey + '.' + relatedFrames[i]?.settings.objectKey
                        }
                        currentFrameFilter = { [filterKey]: this.props.initData?._id }
                    }


                    if (currentFrame?.type == 'collection' && Array.isArray(currentFrame.fields)) {


                        if (!currentFrame.fetchUrl) {
                            let frameInfo
                            if (currentFrame.mode) {
                                frameInfo = framesConfig[currentFrame.mode]
                            }
                            if (!frameInfo) {
                                frameInfo = framesConfig[currentFrame.type]
                            }
                            currentFrame = { ...currentFrame, ...frameInfo }
                        }



                        for (let j = 0; j < currentFrame.fields.length; j++) {
                            let field = currentFrame.fields[j];

                            if (field.key == relatedFrames[i]?.settings.field) {

                                if (field.information) {
                                    if (relatedFrames[i]?.settings.objectKey) {
                                        field.information.default = { [relatedFrames[i]?.settings.objectKey]: this.props.initData?._id }
                                    } else {
                                        field.information.default = this.props.initData?._id
                                    }
                                }

                            }
                        }
                    }





                }



            }

        }

        // console.log(currentFrame, currentFrameFilter)

        this.setState({ currentFrame, currentFrameFilter, relevantInfo, applet }, () => {

            this.createTotalPassData()

            // console.log(applet?._id, this.props.applet?._id)
            if (applet?._id != this.props.applet?._id) {

                if (this.props.cachedRelatedApplets?.[applet?._id]) {

                    let frames = this.props.cachedRelatedApplets?.[applet?._id]?.frames
                    for (let f = 0; f < frames.length; f++) {
                        const element = frames[f];
                        if (element._id == currentFrame._id) {
                            currentFrame = element
                            break
                        }
                    }

                    this.setState({ currentFrame, currentFrameAppletInfo: this.props.cachedRelatedApplets?.[applet?._id] }, () => {
                        this.stageManager.changeStage(page)
                        this.createTotalPassData()
                    })

                } else {
                    this.stageManager.changeStage('loading')

                    this.getOneApplet(applet.slug, applet.hub, (currentFrameAppletInfo) => {

                        let frames = currentFrameAppletInfo?.frames
                        for (let f = 0; f < frames.length; f++) {
                            const element = frames[f];
                            if (element._id == currentFrame._id) {
                                currentFrame = element
                                break
                            }
                        }

                        this.setState({ currentFrame, currentFrameAppletInfo })
                        this.stageManager.changeStage(page)

                    })

                }


            } else {

                currentFrameAppletInfo = {
                    applet: this.props.applet,
                    permissions: this.props.permissions,
                    userSettings: this.props.userSettings,
                    connections: this.props.connections
                }

                this.setState({ currentFrameAppletInfo }, () => {
                    this.stageManager.changeStage(page)
                })
            }
        })


    }




    createTotalPassData = () => {

        let currentFrame = this.state.currentFrame
        let relevantInfo = this.state.relevantInfo
        let params = this.props.params
        let allPassFields = []

        // console.log("params", params)


        let totalPass = {}

        if (relevantInfo && currentFrame) {

            if (relevantInfo?.settings?.field) {

                let fieldKey = relevantInfo.settings?.field

                // if (relevantInfo?.settings.objectKey) {
                //     fieldKey = fieldKey + '.' + relevantInfo?.settings.objectKey
                // }

                allPassFields.push({ key: fieldKey, value: this.props.initData?._id, objectKey: relevantInfo?.settings.objectKey })
                // setObject(totalPass, fieldKey, this.props.initData?._id)

            }

            if (Array.isArray(relevantInfo?.settings?.passData)) {

                allPassFields = [...allPassFields, ...relevantInfo?.settings?.passData]

            }


            for (let i = 0; i < allPassFields.length; i++) {
                const passData = allPassFields[i];


                let value = replaceVariablesLabelWithKeys(passData.value, params, ' - ', 'data')?.content

                if (passData.objectKey) {
                    value = [{ [passData.objectKey]: value }]
                }

                setObject(totalPass, passData.key, value)

            }


            relevantInfo.initData = totalPass
            this.setState({ relevantInfo })
            // console.log("totalPass", totalPass)

        }
    }




    getOneApplet = (slug, hub, cb) => {

        // console.log("getOneApplet", slug, hub)
        let body = { slug, hub }

        this.setState({ isLoadingApplet: true })

        HttpServices.request("getOneApplet", body, (fetchResult, fetchError, status) => {

            this.setState({ isLoadingApplet: false })

            if (fetchError) { return }

            if (this.props.setCachedRelatedApplet) {
                this.props.setCachedRelatedApplet(fetchResult)
            }

            cb(fetchResult)
            // console.log(fetchResult)


        })


    }


    showModal = () => {
        this.open()
    }

    // backAction = () => {

    //     this.onClose()
    //     if (this.form) {
    //         this.form.clearForm()
    //     }
    //     setTimeout(() => {
    //         this.setState({ showModal: false })
    //     }, 500);
    // }




    getFrame = () => {

        HttpServices.request("getFrame", { _id: this.props.page?._id }, (fetchResult, fetchError, status) => {
            // SocketServices.addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)

            this.setState({ isLoading: false })

            if (fetchError) { return }

            let frame = fetchResult?.info


            this.setState({ frame: frame }, () => { })

        })
    }


    _handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            e.stopPropagation()
            this.backAction()
        }
    }




    submitForm = () => {
        // console.log("SUB")
        if (this.props.submitForm) {
            let data = this.form.getForm()
            if (data) {
                this.setState({ isPostingData: true })

                if (this.props.setData) {
                    // this.props.setData('relevantEdit', false, 'CollectionView', () => {
                    this.props.submitForm(data, null, () => {
                        this.setState({ isPostingData: false })
                    })
                    // })
                }
            }
        } else {
            this.postValue()
        }
    }

    formNextPage = () => {
        this.form.nextPage()
    }

    formBackPage = () => {
        this.form.backPage()
    }

    open = () => {
        // this.relevantModal.open()
        this.setState({ showModal: true })
        document.addEventListener("keydown", this._handleKeyDown);

    }

    close = () => {
        this.backAction()
        document.removeEventListener("keydown", this._handleKeyDown);
    }


    onClose = () => {

        // this.props.functionsHandler(null, 'closeOverlayFrame', { id: 'recordViewer' })
        // setTimeout(() => {
        //     if (this.props.setData) {
        //         this.props.setData('currentRelevantTab', 'details', 'CollectionView', () => {
        //             this.props.setData('relevantEdit', false, 'CollectionView', () => {
        //                 this.setState({ showModal: false, currentTab: 'details' })
        //             })
        //         })
        //     } else {

        //         this.setState({ showModal: false, currentTab: null }, () => {
        //             this.setState({ currentTab: 'details' })
        //         })
        //     }
        // }, 10);
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    postValue = () => {
        if (this.form) {
            let data = this.form.getForm()
            this.setState({ errors: null })
            let page = this.props.page
            if (data) {
                let isEditing = data._id ? true : false
                let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
                data.page = this.props.page?.key
                this.setState({ isPostingData: true })
                if (page.postBody) {
                    data = { ...data, ...page.postBody }
                }
                for (const [key, value] of Object.entries(data)) {
                    if (/\{\{(.*?)\}\}/.test(value)) {
                        if (this.props.variables) {
                            data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                        }
                    }
                }
                HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
                    this.setState({ isPostingData: false })
                    if (fetchError) {
                        this.setState({ errors: fetchError.errors })
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                        return
                    }
                    this.backAction()
                    this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })

                    if (!isEditing && this.props.itemAdded) {
                        this.props.itemAdded(fetchResult.info)
                    }
                    if (isEditing && this.props.itemEdited) {
                        if (fetchResult.info) {
                            this.props.itemEdited(fetchResult.info, data._id)
                        } else {
                            this.props.itemEdited(data, data._id)
                        }
                    }
                })
            }
        }
    }

    setFormStatus = (key, value) => {
        this.setState({ [key]: value })
    }

    scrollToTop = () => {
        this.container.scrollTo(0, 0)
    }

    // backButton() {
    //     if (this.state.hasBack) {
    //         return (
    //             <div className=" mld-2"  >
    //                 <div className="" >
    //                     <LoaderButton
    //                         onClick={this.formBackPage}
    //                         text={translate('Back')}
    //                         className={"text-bold text-small text-center flexcc w-100 br-20 py-1  " + (this.state.canSubmit ? '' : 'gray-image')}
    //                         background={'#eee'}
    //                         width={20}
    //                         height={20}
    //                         color={'#777'}
    //                     />
    //                 </div>
    //             </div>
    //         )
    //     }
    // }


    changeTab = (relatedFrame) => {
        // console.log('taaaaaaab');
        if (this.state.currentTab?.frame?._id != relatedFrame?.frame?._id) {
            // this.props.setData('currentRelevantTab', collection._id, 'CollectionView', () => {
            this.setState({ currentTab: relatedFrame }, () => {
                // if (collection.frame?._id != 'details') {
                //     this.props.setData('isLoadingData', true, 'CollectionView', () => { })
                // }
                let windowData = this.props.windowData
                // console.log(windowData)
                // let id = new URLSearchParams(search).get('relevant')
                let path = [...windowData?.path]
                let params = windowData?.params ? { ...windowData?.params } : {}

                // let id = getObject(params, "relevant")

                // console.log(params)
                // let relevantRecords = []
                if (relatedFrame?.frame?._id) {


                    params.relevant = relatedFrame.frame?._id
                    // this.props.headers.map((element) => {
                    //     if (element.type == 'LookupInput') {
                    //         let value = getObject(this.props.initData, element.key)
                    //         if (Array.isArray(value)) {
                    //             relevantRecords = value
                    //         }
                    //         else if (value) {
                    //             relevantRecords.push(value)
                    //         }
                    //     }
                    // })
                    // console.log('taaaaaaaaaab3', relevantRecords);
                    // this.props.fetchRelevantData(relevantRecords)
                    let variables = this.props.variables
                    variables.currentItem = relatedFrame.frame
                    this.setState({ variables })
                    // if (id) {
                    //     path[path.length - 1] = (path[path.length - 1].split('?relevant')[0] + `?relevant=${relatedFrame?.frame?._id}`)
                    // }
                    // else {
                    //     path[path.length - 1] = path[path.length - 1] + `?relevant=${relatedFrame.frame?._id}`
                    // }
                }
                else {

                    delete params.relevant
                    // if (id) {
                    //     path[path.length - 1] = path[path.length - 1].split('?relevant')[0]
                    // }
                }
                // path.splice(0, 2)
                // console.log(path)
                this.props.changeWindow(path, params)
                this.props.setHeader("dummy", 1)
            })
            // })
        }
    }

    // changeTab = (collection) => {
    //     // console.log('taaaaaaab');
    //     if (this.state.currentTab != collection.frame?._id) {
    //         this.props.setData('currentRelevantTab', collection._id, 'CollectionView', () => {
    //             this.setState({ currentTab: collection }, () => {
    //                 if (collection.frame?._id != 'details') {
    //                     this.props.setData('isLoadingData', true, 'CollectionView', () => { })
    //                 }
    //                 let search = window.location.search
    //                 let id = new URLSearchParams(search).get('relevant')
    //                 let path = [...this.props.windowData?.path]
    //                 let relevantRecords = []
    //                 if (collection.frame?._id != 'details') {
    //                     this.props.headers.map((element) => {
    //                         if (element.type == 'LookupInput') {
    //                             let value = getObject(this.props.initData, element.key)
    //                             if (Array.isArray(value)) {
    //                                 relevantRecords = value
    //                             }
    //                             else if (value) {
    //                                 relevantRecords.push(value)
    //                             }
    //                         }
    //                     })
    //                     // console.log('taaaaaaaaaab3', relevantRecords);
    //                     this.props.fetchRelevantData(relevantRecords)
    //                     let variables = this.props.variables
    //                     variables.currentItem = collection.frame
    //                     this.setState({ variables })
    //                     if (id) {
    //                         path[path.length - 1] = (path[path.length - 1].split('?relevant')[0] + `?relevant=${collection._id}`)
    //                     }
    //                     else {
    //                         path[path.length - 1] = path[path.length - 1] + `?relevant=${collection._id}`
    //                     }
    //                 }
    //                 else {
    //                     if (id) {
    //                         path[path.length - 1] = path[path.length - 1].split('?relevant')[0]
    //                     }
    //                 }
    //                 path.splice(0, 2)
    //                 this.props.changeWindowLink(path)
    //             })
    //         })
    //     }
    // }


    setHeader = (key, value) => {

        // console.log(key, value, this.header)


        if (this.header) {
            let frame = this.props.frame ?? this.state.frame
            let showRelatedFrames = false
            if (Array.isArray(frame?.relatedFrames) && frame?.relatedFrames.length > 0) {
                showRelatedFrames = true
            }
            let object


            if (typeof key == 'object') {
                object = {
                    showSettings: true,
                    showFrames: false,
                    backAction: () => this.backAction(),
                    'title': `${checkTranslation(this.props.frame?.name)} | ${translate("View record")}`,
                    subtitle: translate("View record"),
                    showRelatedFrames
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                // this.setState({ headerConfig: object }, () => {
                //     this.header.forceUpdate()
                // })
            }
            else {

                object = { ...this.state.headerConfig, [key]: value }
                // this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                //     // console.log("headerConfig",this.state.headerConfig)
                //     this.header.forceUpdate()
                // })
            }

            object = {
                ...object, ...{
                    backAction: () => this.backAction(),
                    'title': `${checkTranslation(this.props.frame?.name)} | ${translate("View record")}`,
                    subtitle: translate("View record"),
                }
            }

            this.setState({ headerConfig: object }, () => {
                this.header.forceUpdate()
            })
        }
    }

    functionsHandler = (type, name, data, extra, cb) => {

        // if (!type || type == 'frame' || type == 'collection') {
        if (this[name]) {
            this[name](data, extra, cb)
        } else {
            this.props.functionsHandler(type, name, data, extra, cb)
        }
    }


    render() {

        let frame = this.props.frame ?? this.state.frame

        let appletHub = typeof this.state.applet?.hub == 'object' ? this.state.applet?.hub?._id : this.state.applet?.hub

        let variables = {
            ...this.props.variables, ...{
                applet: this.state.applet,
                hub: this.state.applet?.hub,

                appletId: this.state.applet?._id,
                appletHub: appletHub,
                username: this.state.applet?.hub?.username,
                appletSlug: this.state.applet?.slug,
                targetId: appletHub,

                appletSettings: {
                    calendarType: 'jalali',
                    currency: 'ریال',
                },

            }
        }



        // if ((this.props.relevantEdit || this.state.showModal || this.props.isMain)) {
        return (
            <div className=" h-100 h-100 flex-column window-content-radius" style={{ display: 'flex', position: 'fixed', width: 'calc(100% - 50px)', top: '0px', zIndex: 3, backgroundColor: '#fff' }} width={this.props.width} ref={el => this.relevantModal = el} zIndex={30} hideOverlay={false} isMobile={this.props.isMobile} widthCondition={{ xs: "100%", sm: "70%", md: '60%', lg: "50%", xl: "40%" }} onClosed={this.onClose} >


                <div style={{ position: 'relative', top: 0 }}>
                    <Header ref={el => this.header = el} frame={frame} currentTab={this.state.currentTab} changeTab={this.changeTab} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} padding={0} />
                </div>



                <StagesManager height={'0px'} className={'flex-1'} ref={el => this.stageManager = el} fast={true}>

                    <div className="h-100 w-100" stage={1} stageName={'details'}>
                        <RecordContentViewer
                            headers={this.props.headers}
                            // pages={this.props.pages}
                            initData={this.props.initData}
                            data={this.props.initData}
                            width={this.props.width}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            page={this.props.frame}
                            setData={this.props.setData}
                            permissions={this.props.permissions}
                            isMobile={this.props.isMobile}
                            language={this.props.language}
                            frame={this.props.frame}
                            submitForm={this.props.submitForm}
                            onClose={this.props.onClose}
                            variables={this.props.variables}
                            itemAdded={this.props.itemAdded}
                            itemEdited={this.props.itemEdited}
                            windowData={this.props.windowData}
                            fetchRelevantData={this.props.fetchRelevantData}
                            changeWindowLink={this.props.changeWindowLink}
                            functionsHandler={this.functionsHandler}
                            frameActions={this.props.frameActions}
                            applet={this.props.applet}
                            params={this.props.params}

                        />

                    </div>



                    <CollectionView stageName={'collection'} relevant={this.state.relevantInfo} filter={this.state.currentFrameFilter} permissionLevel={this.props.permissionLevel} isMobile={this.props.isMobile} permissions={this.state.currentFrameAppletInfo?.permissions} changeWindow={this.props.changeWindow} changePage={this.props.changePage} updateFrameInfo={this.props.updateFrameInfo} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} modules={this.state.modules} page={this.state.currentFrame} windowData={this.props.windowData} baseUrl={[...this.props.baseUrl]} applet={this.state.currentFrameAppletInfo?.applet} headers={this.state.headers} automations={this.props.automations} language={this.props.language} userSettings={this.state.currentFrameAppletInfo?.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} variables={variables} functionsHandler={this.functionsHandler} appletAccess={this.props.appletAccess} updateUserSettings={this.props.updateUserSettings} />
                    <PageViewer stageName={'page'} relevant={this.state.relevantInfo} permissions={this.state.currentFrameAppletInfo?.permissions} windowData={this.props.windowData} setData={this.setData} setHeader={this.setHeader} colors={this.props.colors} width={this.props.width} height={this.props.height} formPages={this.state.currentFrame?.formPages} changePage={this.props.changePage} page={this.state.currentFrame} baseUrl={[...this.props.baseUrl]} applet={this.state.currentFrameAppletInfo?.applet} userSettings={this.state.currentFrameAppletInfo?.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} goToHub={this.props.goToHub} variables={variables} showToolbar={true} functionsHandler={this.functionsHandler} />

                    <div stageName={'loading'} stage={1}>
                        <div className="pt-5 w-100 flexcc">
                            <CustomLoader isLoading={true} />
                        </div>
                    </div>

                </StagesManager>








                {/* {Array.isArray(frame?.relatedFrames) && frame?.relatedFrames.map((item, index) => {
                    if (item.frame._id == this.state.currentTab?.frame?._id) {
                        return (
                            <div className="h-100" style={{ zIndex: 1, }}>
                                <CollectionView
                                    formPages={this.props.pages}
                                    isMobile={this.props.isMobile}
                                    updateUserSettings={this.props.updateUserSettings}
                                    appletAccess={this.props.appletAccess}
                                    functionsHandler={this.props.mainFunctionsHandler}
                                    lastStagePage={this.props.lastStagePage}
                                    // variables={this.props.mainVariables}
                                    goToHub={this.props.goToHub}
                                    changeStage={this.props.changeStage}
                                    language={this.props.language}
                                    headers={item.fields}
                                    automations={this.props.automations}
                                    modules={this.props.modules}
                                    height={this.props.height}
                                    // setHeader={this.props.setHeader}
                                    setData={this.props.setMainData}
                                    updateFrameInfo={this.props.updateFrameInfo}
                                    changePage={this.props.changePage}
                                    changeWindow={this.props.changeWindow}
                                    permissions={this.props.permissions}
                                    permissionLevel={this.props.permissionLevel}
                                    colors={this.props.colors}
                                    page={item}
                                    fieldOptions={this.props.fieldOptions}
                                    tempValue={this.props.tempValue}
                                    updateRecord={this.props.updateRecord}
                                    clearTempValue={this.props.clearTempValue}
                                    data={this.props.isLoadingData ? [] : this.props.relevantData}
                                    top={0}
                                    applet={this.props.applet}
                                    actions={this.props.actionsBtn}
                                    width={this.props.width}
                                    changeValue={this.props.changeValue}
                                    windowData={this.props.windowData}
                                    changeWindowLink={this.props.changeWindowLink}
                                    saveUserSettings={this.props.saveUserSettings}
                                    userSettings={this.props.userSettings}
                                    stackedKey={this.props.stackedKey}
                                    view={this.props.view}
                                    isLoading={this.props.isLoadingData}
                                    setCurrentHead={this.props.setCurrentHead}
                                    currentHead={this.props.currentHead}
                                    initData={this.props.initData}
                                    deleteHeaderField={this.props.deleteHeaderField}
                                    baseUrl={this.props.baseUrl}
                                    // functionsHandler={this.props.functionsHandler}
                                    variables={variables}
                                    setHeader={this.setHeader}
                                />
                                <div className={"position-absolute"} style={{ bottom: '10px', right: 10, zIndex: 4 }}>
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.props.relevantAddClicked() }}
                                        title={'{{lang}}New Record'}
                                        icon='/assets/icons/plus-white.svg'
                                        textColor={this.props.colors?.textColor}
                                        invert={this.props.colors?.iconInvert}
                                        bg={this.props.colors?.background}
                                    />
                                </div>
                            </div>
                        )
                    }
                })} */}
            </div >
        )
        // } else {
        //     return (
        //         <div></div>
        //     )
        // }
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(RecordViewerModal);